import { StorageEnum } from '../../enums/storage.enum';
import {
  BeneficiaryListDataType,
  GetBeneficiaryListType
} from '../../types/beneficiary.type';

export const getBeneficiary = ():
  | (BeneficiaryListDataType & GetBeneficiaryListType)
  | null => {
  var beneficiary = localStorage.getItem(StorageEnum.Beneficiary);
  if (!beneficiary) return null;

  var parsedBeneficiary: BeneficiaryListDataType & GetBeneficiaryListType =
    JSON.parse(beneficiary);

  return parsedBeneficiary;
};
